import { render, staticRenderFns } from "./FormComponentChoicexchoice.vue?vue&type=template&id=f02f399e"
import script from "./FormComponentChoicexchoice.vue?vue&type=script&lang=js"
export * from "./FormComponentChoicexchoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports